import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_LIKES, RECEIVE_LIKES, REQUEST_SAVES, RECEIVE_SAVES, LIKE_REPORT, SAVE_REPORT } from '../constants/ActionTypes'

//= ===============================
// Fetch Attributes Action
//= ===============================

const requestLikes = (report_id) => {
	return {
		type: REQUEST_LIKES,
		report_id
	}
}

const receiveLikes = (report_id, response) => {
	return {
		type: RECEIVE_LIKES,
		report_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchLikes = (report_id) => {
	return dispatch => {
		dispatch(requestLikes(report_id))
		let url = `${API_URL}/story/likes/` + report_id
		axios.get(url)
		.then((response) => {
			dispatch(receiveLikes(report_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

export const loadLikes = (report_id) => (dispatch, getState) => {
	return dispatch(fetchLikes(report_id))
}

const requestSaves = (report_id) => {
	return {
		type: REQUEST_SAVES,
		report_id
	}
}

const receiveSaves = (report_id, response) => {
	return {
		type: RECEIVE_SAVES,
		report_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchSaves = (report_id) => {
	return dispatch => {
		dispatch(requestSaves(report_id))
		let url = `${API_URL}/story/saves/` + report_id
		axios.get(url)
		.then((response) => {
			dispatch(receiveSaves(report_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

export const loadSaves = (report_id) => (dispatch, getState) => {
	return dispatch(fetchSaves(report_id))
}

//= ===============================
// Post Attributes Action
//= ===============================

export const likeReport = (report_id, type) => (dispatch, getState) => {
	
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let url = `${API_URL}/story/action/` + report_id + `?type=` + type
	axios.post(url, {}, headers)
	.then((response) => {
		dispatch(fetchLikes(report_id))
	})
	.catch((error) => {
		console.log(error)
	})
}

export const saveReport = (report_id, type) => (dispatch, getState) => {
	
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let url = `${API_URL}/story/action/` + report_id + `?type=` + type
	axios.post(url, {}, headers)
	.then((response) => {
		dispatch(fetchSaves(report_id))
	})
	.catch((error) => {
		console.log(error)
	})
}


// WEBPACK FOOTER //
// ./src/actions/attributes.js